import ReactMarkdown from 'react-markdown'
import close_backgr from '../../img/close_backgr.png'
import {getIconById} from "../dataIcons";

import {format, parseISO} from 'date-fns';
import {useContext, useEffect, useState} from "react";

import {isMobile} from 'react-device-detect';
import {LanguageContext} from "../../App";



const Detailed = ({ clicked, setIsDetailed}) => {
    const {language} = useContext(LanguageContext)

    const [height, setHeight] = useState(window.innerHeight)

    const handleResizeWindow = () => setHeight(window.innerHeight);

    useEffect(()=> {
        window.addEventListener("resize", handleResizeWindow);
        return ()=>{
            window.removeEventListener("resize", handleResizeWindow);
        }
    })

    useEffect(() => {
        const script = document.createElement('script');
        script.src = "https://telegram.org/js/telegram-widget.js?18";
        script.async = true;
        const widget = clicked.properties.tg_widget
        if (widget) {
            script.setAttribute('data-telegram-post', widget);
            document.getElementById("tg-widget").appendChild(script);
        }
        return () => {
            // document.getElementById("lol").removeChild(script);
        }
    }, [clicked]);

    const detClass = isMobile ? 'absolute bottom-0 h-5/6 z-20 mb-14' : 'absolute top-0 right-0 h-screen z-20 w-1/2'

    return (
        <div className={detClass}>
            <div className='flex flex-col right-0 bg-white z-20 w-full h-full'

            >
                <div className={'absolute -ml-11'}>
                    <img src={close_backgr} alt="Фон иконки закрытия"
                         style={{height:'65', width:'44px'}}
                    />
                </div>
                <button onClick={() => setIsDetailed(false)} className='absolute -ml-6 h-16 '>
                    <svg className='fill-gray-500 hover:fill-black' width="20" height="20" viewBox="0 0 20 20" xmlns="http://www.w3.org/2000/svg">
                            <path d="M3.932 3.932a.5.5 0 0 1 .638-.058l.07.058 11.428 11.429a.5.5 0 0 1-.638.765l-.07-.058L3.933 4.639a.5.5 0 0 1 0-.707Z">
                            </path>
                            <path  d="M15.36 3.932a.5.5 0 0 1 .766.638l-.058.07L4.639 16.067a.5.5 0 0 1-.765-.638l.058-.07L15.361 3.933Z">
                            </path>
                    </svg>
                </button>
                <div className='sticky top-0'>
                    <div className='h-16 px-10 border-b bg-gray-100 flex items-center justify-between'>
                        <figure className='flex items-center'>
                            <img className='rounded-full bg-red-600 mr-2' style={{height: '24px'}}
                                 src={getIconById(clicked?.properties.protest_type_id)}/>
                            {clicked.properties.protest_type}
                        </figure>
                        { clicked.properties.url ?
                        <a target="_blank" href={clicked.properties.url} className='flex px-4 items-center h-full hover:bg-gray-200'>
                            {language.main_page.side_bar.list.url}
                            <svg className='pl-2' xmlns="http://www.w3.org/2000/svg"  width="24px" height="24px" viewBox="0 0 100 100">
                                <path fill="#010101" d="M82.686,53.754c-2.326,0-4.22,1.89-4.22,4.216v28.362c0,2.897-2.355,5.256-5.252,5.256H13.812   c-2.895,0-5.252-2.358-5.252-5.256V26.934c0-2.896,2.357-5.252,5.252-5.252h28.364c2.326,0,4.217-1.892,4.217-4.218   c0-2.324-1.892-4.216-4.217-4.216H13.812c-3.649,0-7.085,1.425-9.673,4.014c-2.587,2.587-4.014,6.022-4.014,9.672v59.398   c0,7.548,6.14,13.688,13.687,13.688h59.402c7.547,0,13.687-6.14,13.687-13.688V57.97C86.9,55.644,85.012,53.754,82.686,53.754z"/>
                                <path fill="#010101" d="M86.275-0.07h-27.6c-2.318,0-4.202,1.885-4.202,4.203c0,2.317,1.884,4.203,4.202,4.203h26.896   l-48.38,48.375c-0.794,0.797-1.231,1.851-1.231,2.97c0,1.126,0.438,2.182,1.231,2.976c1.583,1.582,4.355,1.585,5.944,0   l48.376-48.377v26.89c0,2.317,1.882,4.201,4.2,4.201c2.317,0,4.202-1.884,4.202-4.201v-27.6C99.915,6.048,93.795-0.07,86.275-0.07z   "/>
                            </svg>
                        </a> : <div>{language.main_page.side_bar.list.no_url}</div>
                        }
                    </div>
                </div>
                <article className='p-6 overflow-auto'
                        >
                    <div className='max-w-prose mx-auto'>
                        <span className='text-gray-500 pb-2'>{format(parseISO(clicked.properties.datetime), 'dd.MM hh:mm')} </span>
                        <h2 className='pb-2 font-medium'>{clicked.properties.title}</h2>
                    </div>
                    <div className='prose m-auto'>
                        <ReactMarkdown className=''>{clicked.properties.text}</ReactMarkdown>
                        <div className='pt-2' id='tg-widget'></div>
                        {/*<article className='pb-2 prose prose-stone'>{clicked?.text}</article>*/}
                        { clicked.properties.url &&
                        <a target="_blank" href={clicked.properties?.url} className='pb-2 flex items-center hover:text-gray-500'>
                            <svg className='pl-1' xmlns="http://www.w3.org/2000/svg"  width="22px" height="22px" viewBox="0 0 100 100">
                                <path fill="#010101" d="M82.686,53.754c-2.326,0-4.22,1.89-4.22,4.216v28.362c0,2.897-2.355,5.256-5.252,5.256H13.812   c-2.895,0-5.252-2.358-5.252-5.256V26.934c0-2.896,2.357-5.252,5.252-5.252h28.364c2.326,0,4.217-1.892,4.217-4.218   c0-2.324-1.892-4.216-4.217-4.216H13.812c-3.649,0-7.085,1.425-9.673,4.014c-2.587,2.587-4.014,6.022-4.014,9.672v59.398   c0,7.548,6.14,13.688,13.687,13.688h59.402c7.547,0,13.687-6.14,13.687-13.688V57.97C86.9,55.644,85.012,53.754,82.686,53.754z"/>
                                <path fill="#010101" d="M86.275-0.07h-27.6c-2.318,0-4.202,1.885-4.202,4.203c0,2.317,1.884,4.203,4.202,4.203h26.896   l-48.38,48.375c-0.794,0.797-1.231,1.851-1.231,2.97c0,1.126,0.438,2.182,1.231,2.976c1.583,1.582,4.355,1.585,5.944,0   l48.376-48.377v26.89c0,2.317,1.882,4.201,4.2,4.201c2.317,0,4.202-1.884,4.202-4.201v-27.6C99.915,6.048,93.795-0.07,86.275-0.07z   "/>
                            </svg>
                            <p className='pl-2'>{language.main_page.side_bar.list.url}</p>
                        </a> }
                    </div>
                    <div className='max-w-prose mx-auto pt-4 border-t'>
                        {language.main_page.side_bar.det_bottom}
                    </div>

                </article>
            </div>
        </div>
    )
}
export default Detailed